import { render, staticRenderFns } from "./bha.vue?vue&type=template&id=b96f67ac&scoped=true"
import script from "./bha.vue?vue&type=script&lang=js"
export * from "./bha.vue?vue&type=script&lang=js"
import style0 from "./bha.vue?vue&type=style&index=0&id=b96f67ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96f67ac",
  null
  
)

export default component.exports